<template>
  <div>
    <div class="middle-search flex">
      <Search @keyword="getKeyword"></Search>
    </div>

    <FlatSelectFilter title="行业" v-model="selected_hangye" :options="list_hangye"></FlatSelectFilter>

    <div class="cmfReportList">
      <ul>
        <div class="no_data_tip_li" v-if="total==0">
          <img src="../../assets/images/error_tip.png" alt="">
        </div>
        <li v-for="(item,index) in list" :key="index">
          <router-link :to="{name:'resultdetail',params:{id:item.id}}">
            <div class="img">
              <img :src="utils.HandleImg(item.img_url,false,1)">
            </div>
            <div class="text">{{item.title}}</div>
          </router-link>
        </li>
      </ul>
      <pagination v-model="pageindex" :total="total" :pagesize="pagesize"></pagination>
    </div>
  </div>
</template>

<script>
import Search from '../../components/Common/Search';
import FlatSelectFilter from '../Common/FlatSelectFilter';
import pagination from '../Common/Pagination';
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageindex: 1,
      pagesize: 15,
      keyword:'',
      list_hangye:[{
        value:'',
        item:'全部'
      }],
      selected_hangye:''
    };
  },
  created() {
    this.GetList();
    this.GetHangyeList();
  },
  components:{
    Search,
    FlatSelectFilter,
    pagination
  },
  methods: {
    GetList() {
      var url = "http://api.xincailiao.com/Open/GetReportList";
      this.$http
        .post(url, {
          pageindex: this.pageindex,
          pagesize: this.pagesize,
          keyword: this.keyword,
          tag_id: this.selected_hangye,
        })
        .then(
          function (res) {
            if (res.data.status == 1) {
              this.list = res.data.ds;
              this.total = res.data.total;
            }
          }.bind(this)
        )
        .catch(function () {});
    },
    getKeyword(_params){
      this.keyword = _params;
    },
    GetHangyeList() {
      var url = "http://api.xincailiao.com/Open/GetFilterItems";
      this.$http.post(url,{id:2}).then(function (res) {
            if (res.data.status == 1) {
              let temp = res.data.ds;
              temp = temp.map((item)=>{
                  return {
                      item:item.item,
                      value:item.id
                  }
              });
              temp.map((item)=>{
                  this.list_hangye.push(item);
              });
            }
          }.bind(this)
        )
        .catch(function () {});
    },
    PropsChange() {
      if (this.pageindex !== 1) this.pageindex = 1;
      else this.GetList();
    },
  },
  watch: {
    pageindex() {
      this.GetList();
    },
    keyword() {
      this.PropsChange();
    },
    selected_hangye() {
      this.PropsChange();
    }
  }
};
</script>